import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: { records: null, totalRecords: null },
  getters,
  mutations,
  actions,
};
